module.exports = __webpack_public_path__ + "img/product.01d39c6f.png";